import loadable from '@loadable/component';

export const LoadableNavBarBottom = loadable(
  () => import('../containers/NavBarBottom'),
);
